import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const BulkUploadForm = ({ 
  apiRes, setApiRes, formErrors, onSubmit, uploadInitValues, setUploadInitValues 
}) => {
  const validateFile = sfile =>{
    if (sfile.length === 1) {
      if (sfile[0].name) {
        if (sfile[0].name.split('.').slice(-1).pop() === 'csv') {
          setUploadInitValues(prev => ({
            ...prev,
            file: sfile[0]
          }));
        } else {
          setApiRes({
            ...apiRes,
            axiosError: true,
            errHeading: 'File Upload',
            errMsg: 'please upload a csv file.',
          });
        }
      } else {
        setApiRes({
          ...apiRes,
          axiosError: true,
          errHeading: 'File Upload',
          errMsg: 'File upload error. Please upload a valid csv file.',
        });
      }
    } else {
      setApiRes({
        ...apiRes,
        axiosError: true,
        errHeading: 'File Upload',
        errMsg: 'File upload error. Please upload a single csv file.',
      });
    }
  };

  return(
    <Grid container spacing={2} style={{ marginTop: 1 }}>
      <Grid 
        item
        xs={11}
      >
        <Box sx={{
          height: 150,
          border: (
            (!uploadInitValues.file && 'file' in formErrors) ? '2px dashed #d32f2f' : '2px dashed black'
          ),
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: 'white',
        }}>
          <Dropzone onDrop={acceptedFiles => validateFile(acceptedFiles)}>
          {({getRootProps, getInputProps}) => (
            <section style={{ marginTop: '30px' }}>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <FileUploadIcon fontSize='large' color={'file' in formErrors ? 'error': 'black'} />
                <Typography color={'file' in formErrors ? 'error': 'black'}><b>Drag 'n' drop csv file here, or click to select file</b></Typography>
                { uploadInitValues.file && <p><i>{uploadInitValues.file.name}</i></p> }
              </div>
            </section>
          )}
          </Dropzone>
        </Box>
        { 
          (!uploadInitValues.file && 'file' in formErrors) && 
          <p style={{ color: '#d32f2f', fontSize: '12px' }}>{formErrors.file}</p> 
        }
      </Grid>
      
      <Grid item xs={1}>
        <Button
          variant="contained" 
          color="primary"
          onClick={onSubmit}
          sx={{ width: '100%'}}
        >
          Upload
        </Button>
      </Grid>
    </Grid>
  );
};

BulkUploadForm.propTypes = {
  uploadInitValues: PropTypes.object.isRequired,
  setUploadInitValues: PropTypes.func.isRequired,
  apiRes: PropTypes.object.isRequired,
  setApiRes: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default BulkUploadForm;